<template>
  <div>
    <el-dialog
      :title="'会议议程'"
      :visible.sync="dialogVisible"
      width="1300px"
    >
      <div class="home">
        <div style="text-align: right;margin-bottom: 10px;">
          <el-button-group>
            <el-button v-pageBtn-lbl="'add'" icon="el-icon-plus" @click="addFormFn">新增</el-button>
            <el-button v-text-lbl="'hygl.hyyt.selectMeeting'" icon="el-icon-document" @click="clickSelectFn">选择议题</el-button>
          </el-button-group>
        </div>
        <el-table v-if="isTableShow" :data="tableData" border row-key="date" class="draggable-table" style="width: 100%" max-height="600">
          <el-table-column type="index" :label="$tx('hygl.hyyt.index','序号')" width="50" align="center"> </el-table-column>
          <el-table-column prop="subject" :label="$tx('hygl.hyyt.meetingAgenda','会议议题')"></el-table-column>
          <el-table-column prop="mainDept" :label="$tx('hygl.hyyt.hostDepartment','主办部门')" width="150" align="center"></el-table-column>
          <el-table-column prop="reportPersonName" :label="$tx('hygl.hyyt.declarant','陈述人')" width="120" align="center"></el-table-column>
          <el-table-column prop="reportTime" :label="$tx('hygl.hyyt.csTime','陈述时间/分钟')" width="150" align="center"></el-table-column>
          <el-table-column prop="talkTime" :label="$tx('hygl.hyyt.talkTime','讨论时间/分钟')" width="150" align="center"></el-table-column>
          <el-table-column prop="status" :label="$tx('hygl.hyyt.status','状态')" width="95" align="center">
            <template slot-scope="scope">
              <div> {{ scope.row.status==0?$tx('hygl.hyyt.noMeeting','未上会'):scope.row.status==1?$tx('hygl.hyyt.onMeeting','已上会'):$tx('hygl.hyyt.waitMeeting','待上会') }} </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="" :label="$tx('hygl.hyyt.attach','附件')" width="70" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.passenger.attachments.length }}</div>
            </template>
          </el-table-column> -->

          <el-table-column prop="orderNo" :label="$tx('hygl.hyyt.order','排序')" width="80" align="center">
            <template slot-scope="scope">
              <div style="display: flex;justify-content: center;" class="handle"><i style="font-size: 18px;" class="el-icon-rank"></i> {{ $tx('hygl.hyyt.move') }} </div>
            </template>
          </el-table-column>
          <el-table-column prop="caozuo" :label="$tx('hygl.hyyt.operate','操作')" width="120" align="center">
            <template slot-scope="scope">
              <div style="display: flex;justify-content: space-evenly;color: #1a82e3;">
                <span v-pageBtn-lbl="'edit'" @click="editFn(scope.row)">编 辑</span>
                <span v-pageBtn-lbl="'del'" @click="delFn(scope.row)">删 除</span>
              </div>
            </template>
          </el-table-column>
        </el-table>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-pageBtn-lbl="'cancel'" @click="dialogVisible = false">取 消</el-button>
        <el-button v-pageBtn-lbl="'sure'" type="primary" @click="saveChange">确 定</el-button>
      </span>
    </el-dialog>

    <Basicform
        v-if="showForm"
      :title="formTitle"
      :win-width="moduleInfo.winWidth"
      :win-height="moduleInfo.winHeight"
      :append-to-body="true"
      :toolbar-btns="busiformBtns"
      :on-basic-form-before-open="onBasicFormBeforeOpen"
      :on-basic-form-submited="onBasicFormSubmited"
    >
      <template #default="slotProps">
        <busi-form ref="ytk" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
      </template>
    </Basicform>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
export default {
    components: {

    },
    props: {

    },
    data() {
        return {
            dialogVisible: false,
            tableData: [],
            row: {},
            moduleInfo: {
                'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/hygl/ytRecord/form.html',
                'winWidth': 1200,
                'delUrl': '/hygl/ytRecord/delete',
                'addNewUrl': '/hygl/ytRecord/addNew',
                'insertUrl': '/hygl/ytRecord/insert',
                'moduleCode': 'budgetKpi',
                'winHeight': 600,
                'updateUrl': '/hygl/ytRecord/update',
                'listDataUrl': '/hygl/ytRecord/listdata',
                'getByIdUrl': '/hygl/ytRecord/getById'
            },
            busiformBtns: [],
            isChange: false,
            isTableShow: true,
            showForm: false,
            formTitle: '新增议题'
        }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    beforeDestroy() {

    },
    mounted() {

    },
    methods: {
        onBasicFormBeforeOpen: function($scope, vo, defer) {
            console.log('ytRecord form before open')

            if (vo.isnew) {
                $scope.title = '新增议题'
            } else {
                $scope.title = '会议议题'
            }

            defer.resolve(true)
        },
        saveChange() {
            if (this.isChange) {
                this.$http({
                    method: 'post',
                    url: '/hygl/meetDirectoryYtRecord/modifyOrderNo',
                    data: this.tableData
                }).then(res => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.dialogVisible = false
                        this.$bus.emit('refreshListData')
                    } else {
                        this.$message.error(res.message)
                    }
                })
            } else {
                this.dialogVisible = false
            }
        },
        clickSelectFn() {
            console.log('11')
            const ids = []
            this.tableData.forEach(item => {
                ids.push(item.ytRecordId)
            })
            var el = {
                attrs: {
                    'listviewurl': `hygl.ytRecord.list_selectWscYt?urlsearch=id!:${ids.join(',')};subjectTypeName:${this.row.subjectTypeName}`,
                    'dialog-title': this.$tx('hygl.hyyt.selectMeeting', '选择议题'),
                    'exclude-fields': '',
                    'retain-btns': 'addObject,editObject',
                    'multiple': true
                }
            }
            const vnode = {
                context: this,
                'data': { model: { expression: '' }}
            }
            this.$bus.emit('openListpageDialog', el, null, vnode)
        },
        // 通用列表选择对话框-选择数据后回调
        onSelectListpageRowCompleted(selectedRows, attr) {
            console.log(attr.listviewurl, 'onSelectListpageRowCompleted')
            const ids = []
            selectedRows.forEach(item => {
                ids.push(item.id)
            })
            if (ids.length > 0) {
                this.$http({
                    method: 'post',
                    url: '/hygl/meetDirectoryYtRecord/relevance',
                    params: {
                        meetDirectoryId: this.row.id,
                        ytRecordIds: ids.join(',')

                    }
                }).then(res => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.getListData(this.row)
                        this.$bus.emit('refreshListData')
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }
        },
        /**
        * 基本表单提交完成，vo为已保存成功的calendar对象，窗口即将关闭，不需要返回值
        */
        onBasicFormSubmited: function($scope, vo) {
            console.log('calendar form submited', this.moduleInfo.isShengcheng)
            if (this.moduleInfo.isShengcheng) {
                this.$http({
                    method: 'post',
                    url: '/hygl/meetDirectoryYtRecord/relevance',
                    params: {
                        meetDirectoryId: this.row.id,
                        ytRecordIds: vo.id

                    }
                }).then(res => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.getListData(this.row)
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }
        },
        addFormFn() {
            this.moduleInfo.isShengcheng = true
            this.moduleInfo.formTemplate = '#/dcontent/vuebusiform/W/hygl.ytRecord.form.vue?sysCode=' + this.$route.meta.sysCode
            this.$options.components['BusiForm'] = this.$loadComponent(this.moduleInfo.formTemplate)
            this.busiformBtns = [
                {
                    id: 'btn_close',
                    btnName: '关 闭',
                    btnIcon: 'close',
                    btnClick: 'closeDialog',
                    btnPermission: '',
                    btnType: '',
                    btnI18nCode: 'close'
                },
                {
                    id: 'btn_save',
                    btnName: '保 存',
                    btnIcon: 'check',
                    btnClick: 'submitBusiform',
                    btnPermission: 'saveObject',
                    btnType: 'primary',
                    btnI18nCode: 'save'
                }
            ]
            this.showForm = true
            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.moduleInfo, null, 1, (res) => {
                    this.moduleInfo.isShengcheng = false
                    this.showForm = false
                    this.getListData(this.row)
                    this.$bus.emit('refreshListData')
                })
            })
        },
        editFn(row) {
            console.log('row', row)

            this.moduleInfo.formTemplate = '#/dcontent/vuebusiform/W/hygl.ytRecord.form.vue?sysCode=' + this.$route.meta.sysCode
            this.$options.components['BusiForm'] = this.$loadComponent(this.moduleInfo.formTemplate)
            this.busiformBtns = [
                {
                    id: 'btn_close',
                    btnName: '关 闭',
                    btnIcon: 'close',
                    btnClick: 'closeDialog',
                    btnPermission: '',
                    btnType: '',
                    btnI18nCode: 'close'
                },
                {
                    id: 'btn_save',
                    btnName: '保 存',
                    btnIcon: 'check',
                    btnClick: 'submitBusiform',
                    btnPermission: 'saveObject',
                    btnType: 'primary',
                    btnI18nCode: 'save'
                }
            ]
            this.showForm = true
            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.moduleInfo, { id: row.ytRecordId }, 1, (res) => {
                    this.getListData(this.row)
                    this.showForm = false
                    this.$bus.emit('refreshListData')
                })
            })
        },
        delFn(row) {
            this.$confirm(this.$tx('hygl.message.delFile', '此操作将永久删除该文件, 是否继续？'), this.$tx('hygl.common.tip', '提示'), {
                confirmButtonText: this.$tx('hygl.common.confirm2', '确 定'),
                cancelButtonText: this.$tx('hygl.common.cancel', '取 消'),
                type: 'warning'
            }).then(() => {
                this.$http({
                    method: 'delete',
                    url: '/hygl/meetDirectoryYtRecord/delete',
                    params: {
                        ids: row.id
                    }
                }).then(res => {
                    if (res.code === 'success') {
                        console.log(res)
                        this.$message.success(res.message)
                        this.getListData(this.row)
                        this.$bus.emit('refreshListData')
                    } else {
                        this.$message.error(res.message)
                    }
                })
            })
        },
        async openDialog(row) {
            this.isChange = false
            this.row = row
            this.tableData = []
            this.dialogVisible = true
            await this.getListData(row)
            this.$nextTick(() => {
                this.register()
            })
        },
        register() {
            const _this = this
            const tbody = document.querySelector('.draggable-table .el-table__body-wrapper tbody')
            new Sortable(tbody, {
                handle: '.handle', // handle's class
                animation: 150,
                // 需要在odEnd方法中处理原始eltable数据，使原始数据与显示数据保持顺序一致
                onEnd: ({ newIndex, oldIndex }) => {
                    this.isTableShow = false
                    console.log('newIndex', newIndex)
                    console.log('oldIndex', oldIndex)
                    const targetRow = this.tableData[oldIndex]
                    this.tableData.splice(oldIndex, 1)
                    this.tableData.splice(newIndex, 0, targetRow)
                    console.table(this.tableData)
                    this.$nextTick(() => {
                        this.$forceUpdate()
                        this.isTableShow = true
                        this.$nextTick(() => {
                            _this.register()
                        })
                    })
                    this.isChange = true
                }
            })
        },
        getListData(row) {
            this.$http({
                method: 'post',
                url: '/hygl/vwHyglMeetDirectoryYtRecord/listdata',
                params: {
                    pageSize: 9999,
                    pageNum: 1,
                    urlsearch: `meetDirectoryId:${row.id}`,
                    orderBy: 'orderNo asc'
                }
            }).then(res => {
                if (res.code === 'success') {
                    console.log('res', res)
                    this.tableData = res.body.pageInfo.list
                }
            })
        }

    }
}
</script>

<style scoped lang="scss">

  .handle {
    cursor: move;
    display: flex;
    align-content: center;
  }

</style>
